// removed by extract-text-webpack-plugin
module.exports = {"or":"style__or__3u8iz","links":"style__links__1h1cI","helpBox":"style__helpBox__1-Ftx","loginContainer":"style__loginContainer__gEu1G","login":"style__login__3q63k","info":"style__info__2t0IC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/style.scss
// module id = 464
// module chunks = 0